// --------------------------------------------------------------
// Created On: 2022-05-26
// Author: Zachary Thomas
//
// Last Modified: 2023-07-18
// Modified By: Zachary Thomas
//
// Copyright 2022 - 2023 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Converts API response body into error message.
export default function generateErrorMessage<Type>(
  responseBody: Type,
  statusCode: number,
  defaultError: string
): string {
  if (statusCode >= 500) {
    // Don't attempt to find an error message for internal server errors.
    return `Internal server error. ${defaultError}`;
  } else if (
    typeof responseBody === "object" &&
    !Array.isArray(responseBody) &&
    responseBody !== null &&
    "error" in responseBody &&
    typeof (responseBody as ErrorObject).error === "string"
  ) {
    // If it is not a server error, go ahead and return the error message to the user.
    return (responseBody as ErrorObject).error;
  } else {
    // If the response does not include a proper error message, return a default error.
    return `Internal server error. ${defaultError}`;
  }
}

interface ErrorObject {
  error: string;
}
